import { Button } from "@nxtvid/component-library"
import './stripeOnboardingRefresh.css';

const StripeOnboardingRefresh = () =>{
    return(
        <div className="stripe-onboarding-refreshed-message">
            <h2>Stripe Onboarding Refreshed</h2>
            <p>
                The onboarding process was refreshed. To try again, please return to your Inbox and attempt to request another payment.
            </p>
            <Button size='medium' type='primary' label='Go Back to Inbox' onClick={()=>window.location.href = '/Inbox'}/>
        </div>
    )
}

export default StripeOnboardingRefresh;